module.exports = __webpack_public_path__ + "static/media/IMG_4876.35f2fd71.JPG";